<mat-tab-group
  dynamicHeight
  [selectedIndex]="selected.value"
  [disablePagination]="true"
  (selectedIndexChange)="selected.setValue($event)"
>
  <mat-tab label="{{ 'P2P_WIDGETS.BUY' | translate }}">
    <csgofast-p2p-purchase></csgofast-p2p-purchase>
  </mat-tab>
  <mat-tab label="{{ 'P2P_WIDGETS.SELL' | translate }}">
    <csgofast-p2p-sell></csgofast-p2p-sell>
  </mat-tab>
  <mat-tab label="{{ 'Settings' }}">
    <csgofast-p2p-settings></csgofast-p2p-settings>
  </mat-tab>
</mat-tab-group>
